import React, { Component } from 'react'
import Rich from '../RichText/RichTextEditor';

export default class FormOne extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            f_name: '',
            m_name: '',
            l_name: '',
            subject: '',
            message: '',
            type: '',
            grievance_type: '',
            phone: '',
            email: ''
        }

        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleEditorChange(e) {
        this.setState({
            message: e
        })
    }

    onChange(e){
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit(e){
        e.preventDefault();

        let name = this.state.f_name + ' ' + this.state.m_name + ' ' + this.state.l_name;

        const data = {
            name: name,
            type: this.state.type,
            phone: this.state.phone,
            email: this.state.email,
            subject: this.state.subject,
            grievance_type: this.state.grievance_type,
            message: this.state.message
        }


        this.props.onSubmit(data);


        //clear the state

        this.setState({
            name: '',
            f_name: '',
            m_name: '',
            l_name: '',
            subject: '',
            message: '',
            type: '',
            grievance_type: '',
            phone: '',
            email: ''
        })
    }

    render() {
        return (
            <div>
                <form className="form" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>First Name</label>
                                <input
                                    className="form-control input-sm"
                                    placeholder="First Name"
                                    name="f_name"
                                    value={this.state.f_name}
                                    onChange={this.onChange}
                                    required={true} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Middle Name</label>
                                <input
                                    className="form-control input-sm"
                                    placeholder="Middle Name"
                                    name="m_name"
                                    value={this.state.m_name}
                                    onChange={this.onChange} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Last Name</label>
                                <input
                                    className="form-control input-sm"
                                    placeholder="Last Name"
                                    name="l_name"
                                    value={this.state.l_name}
                                    onChange={this.onChange}
                                    required={true} />
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Submitted By</label>
                                <select
                                    className="form-control input-sm"
                                    name="type"
                                    value={this.state.type}
                                    onChange={this.onChange}
                                    required={true}
                                >
                                    <option value="">Choose Type</option>
                                    <option value="STUDENT">STUDENT</option>
                                    <option value="FACULTY">FACULTY</option>
                                    <option value="STAFF">STAFF</option>
                                    <option value="GUEST">GUEST</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Type of Grievance</label>
                                <select
                                    className="form-control input-sm"
                                    name="grievance_type"
                                    value={this.state.grievance_type}
                                    onChange={this.onChange}
                                    required={true}
                                >
                                    <option value="">Choose Type</option>
                                    <option value="Sexual Harrasment">Sexual Harrasment</option>
                                    <option value="Ragging">Ragging</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input
                                    type="number"
                                    className="form-control input-sm"
                                    placeholder="Phone Number"
                                    name="phone"
                                    value={this.state.phone}
                                    onChange={this.onChange}
                                    required={true} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Email id</label>
                                <input
                                    type="email"
                                    className="form-control input-sm"
                                    placeholder="Email id"
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.onChange} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Subject</label>
                                <textarea
                                    className="form-control input-sm"
                                    placeholder="Your subject here"
                                    name="subject"
                                    value={this.state.subject}
                                    onChange={this.onChange}
                                    required={true}
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Describe your issue here</label>
                                <Rich
                                    onChange={this.handleEditorChange}
                                    placeholder="Describe your issue here" />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12" align="center">
                            <div className="form-group">
                                <button className="btn btn-sm btn-primary" type="submit" style={{backgroundColor: "#6b0b3e"}}>Submit</button>&nbsp;
                                <button className="btn btn-sm" type="button">Clear</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Grievance/FormOne.js